{
  "invalidSelection": "選択した{selectedCount, plural, one {日付} other {日付}}は使用できません。"
}
